export const ARTICLE_CONTENT_TYPES = {
  PARAGRAPH: 'PARAGRAPH',
  HEADING: 'HEADING',
  BULLETS: 'BULLETS',
} as const;

export type ArticleContentType = (typeof ARTICLE_CONTENT_TYPES)[keyof typeof ARTICLE_CONTENT_TYPES];
